/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable unicorn/catch-error-name */
/* eslint-disable camelcase */
export const identifyUser = () => {
  try {
    const inStorage = localStorage.getItem('user')
    const user = JSON.parse(inStorage)
    try {
      const identity = _.extend({}, user, {
        name: `${user.firstName} ${user.lastName}`,
        Name: `${user.firstName} ${user.lastName}`,
      })
      console.debug('identifyUser:', {identity, user})
      analytics.identify(user.id, identity)
    } catch (error) {
      console.error('analytics.identify', error)
    }

    return user
  } catch (e) {
    console.error('Track: identifyUser error', e)
  }
}

/* Pre-User Acquisition */
export const homepageMainCTA = type => {
  if (type === 'Who Is Hiring') {
    analytics.track('homepage main cta', {
      event: 'lexstep_webapp',
      eventCategory: 'pre-user acquisition',
      eventAction: 'homepage main cta',
      eventLabel: 'click',
    })
  } else if (type === 'Request Access Now') {
    analytics.track('signing bonus request access', {
      event: 'lexstep_webapp',
      eventCategory: 'pre-user acquisition',
      eventAction: 'signing bonus request access',
      eventLabel: 'click',
    })
  } else if (type === 'Get Started Now') {
    analytics.track('how it works get started now', {
      event: 'lexstep_webapp',
      eventCategory: 'pre-user acquisition',
      eventAction: 'how it works get started now',
      eventLabel: 'click',
    })
  }
}

export const menuVideos = () => {
  analytics.track('menu videos', {
    event: 'lexstep_webapp',
    eventCategory: 'pre-user acquisition',
    eventAction: 'menu videos',
    eventLabel: 'click',
  })
}

export const getStarted = () => {
  analytics.track('get started', {
    event: 'lexstep_webapp',
    eventCategory: 'pre-user acquisition',
    eventAction: 'get started',
    eventLabel: 'click',
  })
}

export const blogBannerGetStarted = () => {
  analytics.track('blog banner get started', {
    event: 'lexstep_webapp',
    eventCategory: 'pre-user acquisition',
    eventAction: 'blog banner get started',
    eventLabel: 'click',
  })
}

export const socialButtonClick = type => {
  analytics.track('social button clicks footer', {
    event: 'lexstep_webapp',
    eventCategory: 'pre-user acquisition',
    eventAction: 'social button clicks footer',
    eventLabel: 'click',
    social: type,
  })
}

/* Lead Acquisition */
export const earnOneThousandGetYourLink = (first_Name, last_Name, email) => {
  try {
    analytics.track('earn 1000 get your link', {
      event: 'lexstep_webapp',
      eventCategory: 'lead acquisition',
      eventAction: 'earn 1000 get your link',
      eventLabel: 'submit',
      first_Name,
      last_Name,
      email,
    })
  } catch (e) {
    console.log('Track: earnOneThousandGetYourLink', e)
  }
}

export const copyLinkClipboard = () => {
  try {
    analytics.track('copy link clipboard', {
      event: 'lexstep_webapp',
      eventCategory: 'lead acquisition',
      eventAction: 'copy link clipboard',
      eventLabel: 'click',
    })
  } catch (e) {
    console.log('Track: copyLinkClipboard', e)
  }
}

export const shareFacebook = () => {
  try {
    analytics.track('share facebook', {
      event: 'lexstep_webapp',
      eventCategory: 'lead acquisition',
      eventAction: 'share facebook',
      eventLabel: 'submit',
    })
  } catch (e) {
    console.log('Track: shareFacebook', e)
  }
}

export const sendEmailEvent = () => {
  try {
    analytics.track('send email', {
      event: 'lexstep_webapp',
      eventCategory: 'lead acquisition',
      eventAction: 'send email',
      eventLabel: 'submit',
    })
  } catch (e) {
    console.log('Track: sendEmailEvent', e)
  }
}

/* User Acquisition */
export const signUpPageView = () => {
  try {
    analytics.track('sign up - page view', {
      event: 'lexstep_webapp',
      eventCategory: 'user acquisition',
      eventAction: 'sign up - page view',
      eventLabel: '',
    })
  } catch (e) {
    console.log('Track: signUpPageView', e)
  }
}

export const signUpGetStartedEvent = () => {
  try {
    analytics.track('sign up - get started', {
      event: 'lexstep_webapp',
      eventCategory: 'user acquisition',
      eventAction: 'sign up - get started',
      eventLabel: 'submit',
    })
  } catch (e) {
    console.log('Track: signUpGetStarted', e)
  }
}

export const signUpRequestAccess = (
  nationality,
  current_location,
  /* Category, */ phone,
  date_commenced_practice,
  jurisdictions,
  practice_areas,
  target_location,
  linkedin,
  cv
) => {
  try {
    analytics.track('sign up - request access', {
      event: 'lexstep_webapp',
      eventCategory: 'user acquisition',
      eventAction: 'sign up - request access',
      eventLabel: 'submit',
      nationality,
      current_location,
      /* Category, */
      phone,
      date_commenced_practice,
      jurisdictions,
      practice_areas,
      target_location,
      linkedin,
      cv,
    })
  } catch (e) {
    console.log('Track: signUpRequestAccess', e)
  }
}

export const signUpLinkedInConnect = () => {
  try {
    analytics.track('sign up - linkedin connect', {
      event: 'lexstep_webapp',
      eventCategory: 'user acquisition',
      eventAction: 'sign up - linkedin connect',
      eventLabel: 'submit',
    })
  } catch (e) {
    console.log('Track: signUpLinkedInConnect', e)
  }
}

export const signUpCVUpload = () => {
  try {
    analytics.track('sign up - cv upload', {
      event: 'lexstep_webapp',
      eventCategory: 'user acquisition',
      eventAction: 'sign up - cv upload',
      eventLabel: 'submit',
    })
  } catch (e) {
    console.log('Track: signUpCVUpload', e)
  }
}

export const hiringFormSubmission = (
  name,
  email,
  company_name,
  job_type,
  where_did_you_hear_about_us
) => {
  try {
    analytics.track('hiring - form submission', {
      event: 'lexstep_webapp',
      eventCategory: 'user acquisition',
      eventAction: 'hiring - form submission',
      eventLabel: 'submit',
      name,
      email,
      company_name,
      job_type,
      where_did_you_hear_about_us,
    })
  } catch (e) {
    console.log('Track: hiringFormSubmission', e)
  }
}

/* Post User Acquisition */
export const jobView = (
  job_id,
  job_company,
  job_title,
  job_pqe,
  job_contract,
  job_role,
  job_address,
  job_type,
  firm_name,
  firm_id
) => {
  try {
    const options = {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'job - view',
      eventLabel: 'click',
      job_id,
      job_company,
      job_title,
      job_pqe,
      job_contract,
      job_role,
      job_address,
      job_type,
      firm_name,
      firm_id,
    }

    console.debug('Tracking "job - view"', options)
    analytics.track('job - view', options)
  } catch (e) {
    console.log('Track: jobView', e)
  }
}

export const jobInterested = (
  job_id,
  job_company,
  job_title,
  job_pqe,
  job_contract,
  job_role,
  job_address,
  job_type,
  firm_name,
  firm_id
) => {
  try {
    analytics.track('job - interested', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'job - interested',
      eventLabel: 'submit',
      job_id,
      job_company,
      job_title,
      job_pqe,
      job_contract,
      job_role,
      job_address,
      job_type,
      firm_name,
      firm_id,
    })
  } catch (e) {
    console.log('Track: jobInterested', e)
  }
}

export const jobShareProfile = (
  job_id,
  job_company,
  job_title,
  job_pqe,
  job_contract,
  job_role,
  job_address,
  job_type,
  firm_name,
  firm_id
) => {
  try {
    analytics.track('job - share profile', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'job - share profile',
      eventLabel: 'submit',
      job_id,
      job_company,
      job_title,
      job_pqe,
      job_contract,
      job_role,
      job_address,
      job_type,
      firm_name,
      firm_id,
    })
  } catch (e) {
    console.log('Track: jobView', e)
  }
}

export const jobNotForMe = (
  job_id,
  job_company,
  job_title,
  job_pqe,
  job_contract,
  job_role,
  job_address,
  job_type,
  firm_name,
  firm_id
) => {
  try {
    analytics.track('job - not for me', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'job - not for me',
      eventLabel: 'submit',
      job_id,
      job_company,
      job_title,
      job_pqe,
      job_contract,
      job_role,
      job_address,
      job_type,
      firm_name,
      firm_id,
    })
  } catch (e) {
    console.log('Track: jobNotForMe', e)
  }
}

export const searchMyPracticeArea = practice_area => {
  try {
    analytics.track('search - my practice area ', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'search - my practice area ',
      eventLabel: 'submit',
      practice_area,
    })
  } catch (e) {
    console.log('Track: searchMyPracticeArea', e)
  }
}

export const searchLocation = location => {
  try {
    analytics.track('search - location', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'search - location',
      eventLabel: 'submit',
      location,
    })
  } catch (e) {
    console.log('Track: searchLocation', e)
  }
}

export const searchPQESelected = pqe => {
  try {
    analytics.track('search - pqe - selected', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'search - pqe - selected',
      eventLabel: 'submit',
      pqe,
    })
  } catch (e) {
    console.log('Track: searchPQESelected', e)
  }
}

export const makeMeAnOffer = () => {
  try {
    analytics.track('make me an offer ', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'make me an offer ',
      eventLabel: 'click',
    })
  } catch (e) {
    console.log('Track: makeMeAnOffer', e)
  }
}

export const dropUsANoteFormSubmission = () => {
  // Try {
  // } catch (error) {
  //     console.log("Track: jobView", e);
  // }
  analytics.track('drop us a note - form submission', {
    event: 'lexstep_webapp',
    eventCategory: 'post-user acquisition',
    eventAction: 'drop us a note - form submission',
    eventLabel: 'submit',
  })
}

export const trackOpen = () => {
  try {
    analytics.track('track - open', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'track - open',
      eventLabel: 'submit',
    })
  } catch (e) {
    console.log('Track: trackOpen', e)
  }
}

export const trackViewJob = (
  job_id,
  job_company,
  job_title,
  job_pqe,
  firm_name,
  firm_id
) => {
  try {
    analytics.track('track - view job', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'track - view job',
      eventLabel: 'submit',
      job_id,
      job_company,
      job_title,
      job_pqe,
      // Job_contract: [],
      // job_role: [],
      // job_address: [],
      // job_type: [],
      firm_name,
      firm_id,
    })
  } catch (e) {
    console.log('Track: trackViewJob', e)
  }
}

export const profileCVAdd = cv => {
  try {
    analytics.track('profile - cv - add', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'profile - cv - add',
      eventLabel: 'submit',
      cv,
    })
  } catch (e) {
    console.log('Track: profileCVAdd', e)
  }
}

export const profileExperienceAdd = experience => {
  try {
    analytics.track('profile - experience - add', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'profile - experience - add',
      eventLabel: 'submit',
      experience,
    })
  } catch (e) {
    console.log('Track: profileExperienceAdd', e)
  }
}

export const profileAboutYouUpdate = about_you => {
  try {
    analytics.track('profile - about you - update', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'profile - about you - update',
      eventLabel: 'submit',
      about_you,
    })
  } catch (e) {
    console.log('Track: profileAboutYouUpdate', e)
  }
}

export const profileLanguageUpdate = language => {
  try {
    analytics.track('profile - language - update', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'profile - language - update',
      eventLabel: 'submit',
      language,
    })
  } catch (e) {
    console.log('Track: profileLanguageUpdate', e)
  }
}

export const profileJuridictionUpdate = juridiction => {
  try {
    analytics.track('profile - juridiction - update', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'profile - juridiction - update',
      eventLabel: 'submit',
      juridiction,
    })
  } catch (e) {
    console.log('Track: profileJuridictionUpdate', e)
  }
}

export const profilePracticeAreaUpdate = practice_area => {
  try {
    analytics.track('profile - practice area - update', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'profile - practice area - update',
      eventLabel: 'submit',
      practice_area,
    })
  } catch (e) {
    console.log('Track: profilePracticeAreaUpdate', e)
  }
}

export const profileSalaryDetailsAdd = salary => {
  try {
    analytics.track('profile - salary details - add', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'profile - salary details - add',
      eventLabel: 'submit',
      salary,
    })
  } catch (e) {
    console.log('Track: profileSalaryDetailsAdd', e)
  }
}

export const profileTargetLocationsUpdate = target_location => {
  try {
    analytics.track('profile - target locations - update', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'profile - target locations - update',
      eventLabel: 'submit',
      target_location,
    })
  } catch (e) {
    console.log('Track: profileTargetLocationsUpdate', e)
  }
}

export const profileContractUpdate = contract => {
  try {
    analytics.track('profile - contract - update', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'profile - contract - update',
      eventLabel: 'submit',
      contract,
    })
  } catch (e) {
    console.log('Track: profileContractUpdate', e)
  }
}

export const profileRoleUpdate = role => {
  try {
    analytics.track('profile - role - update', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'profile - role - update',
      eventLabel: 'submit',
      role,
    })
  } catch (e) {
    console.log('Track: profileRoleUpdate', e)
  }
}

export const profileTargetEmployerTypeUpdate = target_employer_type => {
  try {
    analytics.track('profile - target employer type - update', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'profile - target employer type - update',
      eventLabel: 'submit',
      target_employer_type,
    })
  } catch (e) {
    console.log('Track: profileTargetEmployerTypeUpdate', e)
  }
}

export const profileInfosUpdate = () => {
  try {
    analytics.track('profile - infos - update', {
      event: 'lexstep_webapp',
      eventCategory: 'post-user acquisition',
      eventAction: 'profile - infos - update',
      eventLabel: 'submit',
    })
  } catch (e) {
    console.log('Track: profileInfosUpdate', e)
  }
}

/* Retention */
export const trackLogin = user => {
  try {
    const user_id = user.id
    const name = `${user.firstName} ${user.lastName}`

    analytics.track(
      'login',
      _.extend({}, user, {
        event: 'lexstep_webapp',
        eventCategory: 'retention',
        eventAction: 'login',
        eventLabel: 'submit',
        name,
        user_id,
        currentEmployerName:
          user && user.employer ? user.employer.name : undefined,
      })
    )
  } catch (e) {
    console.log('Track: trackLogin', e)
  }
}



// WEBPACK FOOTER //
// ./scripts/segment.js